// import { useNavigate } from "react-router-dom";
import BackpageStyles from "./Backpage.module.css"
import FrontBookCover from "./photos/BookDecorWebP/BookofAbdul_FrontBookCover.webp";
import BackBookCover from "./photos/BookDecorWebP/BookofAbdul_BackBookCover.webp";
import OpenBookCover from "./photos/BookDecorWebP/BookofAbdul_BookCover.webp";
import IndividualPage from "./photos/BookDecorWebP/BookofAbdul_Pages(Individual).webp";

function Home() {

    const back = 
        {
            title: "BackBookCover",
            photo: BackBookCover,
            id: 1
        };

    const open = 
        {
            title: "OpenBookCover",
            photo: OpenBookCover,
            id: 2
        };

    const page = 
        {
            title: "IndividualPage",
            photo: IndividualPage,
            id: 3
        };

    const front = 
        {
            title: "FrontBookCover",
            photo: FrontBookCover,
            id: 4
        };

    const pagenums = 13;

    return (
        <section className="Book-of-Abdul-Book-Placement">
            <div id="BoA-book-cover-open" style={{opacity: "0.0"}}>
                <img id="BoA-open-img" src={open.photo} alt={open.title}/>
            </div>
            <div id="BoA-book-cover-front" style={{opacity: "0.0"}}>
                <img id="BoA-front-img" src={front.photo} alt={front.title}/>  
            </div>
            <div className="BoA-background-pages" id="BoA-background-pages" style={{opacity: "0.0"}}>
                <ul className={BackpageStyles["BoA-individual-pages"]}>
                    {[...Array(pagenums)].map((e, i) => (
                        <li className={"BoA-backpage-" + i} key={i}>
                            <img className="BoA-page-img" src={page.photo} alt={page.title} key={e}/>
                        </li>
                    ))}
                </ul>
            </div>
            <div id="BoA-book-cover-back">
                <img id="BoA-back-img" src={back.photo} alt={back.title}/>
            </div>
        </section>
    ); 
}

export default Home;